export default {"src":"/_next/static/media/vs.22db3049.svg","height":23,"width":16,"blurWidth":0,"blurHeight":0};